import React from 'react';
import { ApiUrl, AppPages } from 'project/Defines.js';
import { EVENT_NAME } from 'project/utilities';
import ListView from 'Shared/ListView';
import { COLUMN_TYPE } from 'Shared/ListView/helper';
import { Project } from '../../../project/Project';

/**
 * Parameters list of setup
 * @exports SetupParameters
 */
export default function SetupParameters(props) {

    const columnConfig = [
        {
            text: 'text.name',
            field: 'nom',
            type: COLUMN_TYPE.TEXT,
            linkAppPage: AppPages.SetupProductParameterDetails
        },
        {
            type: COLUMN_TYPE.ACTION,
        },
    ];

    return (
        <ListView
            {...props}
            columnConfig={columnConfig}
            apiUrl={ApiUrl.ParameterList}
            deleteUrl={ApiUrl.ParameterDelete}
            detailUrl={Project.getPageUrl(AppPages.SetupProductParameterDetails)}
            filters={[{ name: 'traduction', type: 'text', text: 'text.name' }]}
            newButtonTip='text.create_new_parameter'
            listUpdateEvent={EVENT_NAME.SETUP_PRODUCT_PARAMETER_LIST_UPDATE}
            detailProps={{ newTitle: 'text.create_new_parameter', editTitle: 'text.edit_parameter' }}
            listName={AppPages.SetupProductParameter}
            showRefreshButton={false} />

    );
}
